/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { AevoNFT, AevoNFTInterface } from "../AevoNFT";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "adminBatchMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "adminMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "owners",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "balances",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "exchangePassId",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "tokenUri",
        type: "string",
      },
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type AevoNFTConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AevoNFTConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AevoNFT__factory extends ContractFactory {
  constructor(...args: AevoNFTConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<AevoNFT> {
    return super.deploy(overrides || {}) as Promise<AevoNFT>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): AevoNFT {
    return super.attach(address) as AevoNFT;
  }
  override connect(signer: Signer): AevoNFT__factory {
    return super.connect(signer) as AevoNFT__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AevoNFTInterface {
    return new utils.Interface(_abi) as AevoNFTInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AevoNFT {
    return new Contract(address, _abi, signerOrProvider) as AevoNFT;
  }
}
